/// <reference types="@types/google.maps" />
// Add the above line (with 3 ///) before any imports in order to resolve the issue cannot find namespace "google"

import { Injectable } from '@angular/core';

const getScriptSrc = (callbackName : any) => {
	return `https://maps.googleapis.com/maps/api/js?key=AIzaSyBdVmh-J0TRK-wHotg5oAaozZoUp8Cu7g0&language=en&callback=${callbackName}`;
}

@Injectable()
export class GoogleMapService {

	private map: google.maps.Map;
	//private geocoder: google.maps.Geocoder;
	private scriptLoadingPromise: Promise<void>;
  
	constructor() {
		//Loading script
		this.loadScriptLoadingPromise();
		//Loading other components
		this.onReady().then(() => {
			//this.geocoder = new google.maps.Geocoder();
		});
	}
  
	onReady(): Promise<void> {
		return this.scriptLoadingPromise;
	}
  
	initMap(mapHtmlElement: HTMLElement, options: google.maps.MapOptions): Promise<google.maps.Map> {
		return this.onReady().then(() => {
			return this.map = new google.maps.Map(mapHtmlElement, options);
		});
	}
  
	private loadScriptLoadingPromise() {
		const script = window.document.createElement('script');
		script.type = 'text/javascript';
		script.async = true;
		script.defer = true;
		const callbackName = 'UNIQUE_NAME_HERE';
		script.src = getScriptSrc(callbackName);
		this.scriptLoadingPromise = new Promise<void>((resolve, reject) => {
			(<any>window)[callbackName] = () => { resolve(); };
  
			script.onerror = (event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error) => { reject(error); };
		});
		window.document.body.appendChild(script);
	}
  
	// /** Exemple of wrapped to promise API */
	// geocode(address: string | google.maps.GeocoderRequest): Promise<google.maps.GeocoderResult[]> {
	//   return this.onReady().then(() => {
	//     this.geocoder.geocode(typeof address == "google.maps.GeocoderRequest" ? address: {address: address},
	//         (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
	//           if(status == google.maps.GeocoderStatus.OK) {
	//             return results;
	//           } else {
	//             throw new Error(status.toString());
	//           }
	//     });
	//   });
	// });
  
}